import { Group, Text, ThemeIcon } from "@mantine/core";

const AccordionFilterLabel = ({ label, icon, color }) => (
  <Group className="overview-accordion-icon">
    <ThemeIcon color={color} variant="light">
      {icon()}
    </ThemeIcon>
    <Text>{label}</Text>
  </Group>
);

export default AccordionFilterLabel;
